import PotencyFilter from './potency-filter';

export default PotencyFilter;
